var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.record.label !== '')?_c('Divider',{attrs:{"orientation":_vm.record.options.orientation || 'center'}},[_vm._v(_vm._s(_vm.record.label))]):(_vm.record.label === '')?_c('Divider'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }